// extracted by mini-css-extract-plugin
module.exports = {"leadImageFigure":"aumMM","content":"xVF3w","caption":"MVoOv"};